import { ExportOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Alert, Button, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';

function findMenu(nodes: any[], id: string): any { for (const item of nodes) { if (item.id === id) return item; const child = findMenu(item.children ?? [], id); if (child) return child; } }
export function ExternalPage() {
  const { menuId = '' } = useParams();
  const { data = [], isLoading } = useQuery<any[]>({ queryKey: ['navigation-menus'], queryFn: async () => (await api.get('/menus/navigation')).data });
  const menu = findMenu(data, menuId);
  if (isLoading) return <div className="page"><Spin /></div>;
  if (!menu?.externalUrl) return <div className="page"><Alert type="error" message="外部菜单不存在或未配置URL" /></div>;
  return <div className="external-page"><div className="external-toolbar"><strong>{menu.name}</strong><Button icon={<ExportOutlined />} href={menu.externalUrl} target="_blank">在新窗口打开</Button></div><iframe title={menu.name} src={menu.externalUrl} sandbox="allow-forms allow-modals allow-popups allow-same-origin allow-scripts" referrerPolicy="no-referrer" /></div>;
}
